<template>
    <div class="honour">
        <div class="box" v-for="(value,index) in list" :key="index">
            <img :src="value.img" alt="">
            <p class="text">
                {{value.title}}
            </p>
        </div>
    </div>
</template>
<script>
export default {
    name:"honour",
    data(){
        return{
            list:[{
                img:require('../assets/honour1.png'),
                title:"2017年 高新技术企业证书"
            },{
                img:require('../assets/honour2.png'),
                title:"发明专利证书"
            },{
                img:require('../assets/honour3.png'),
                title:"2019年 规范统计证书"
            },{
                img:require('../assets/honour4.png'),
                title:"机械行业能力评价考试站"
            },{
                img:require('../assets/honour5.png'),
                title:"科技创业优秀企业"
            },{
                img:require('../assets/honour6.png'),
                title:"千企万人支持计划——认定企业"
            },{
                img:require('../assets/honour7.png'),
                title:"2019年 软件企业证书"
            },{
                img:require('../assets/honour8.png'),
                title:"网络教学铜奖"
            },{
                img:require('../assets/honour9.png'),
                title:"武汉理工大学人才联合培养地"
            },{
                img:require('../assets/honour10.png'),
                title:"2019年 信促会会员证"
            },{
                img:require('../assets/honour11.png'),
                title:"一带一路金砖联盟会员证书"
            }]
        }
    }
}
</script>
<style lang="stylus" scoped>
.honour
    padding:40px 30px;
    overflow:hidden;
    .box
        width:33.3%;
        float:left;
        
        p
            color:#333;
            text-align:center;
            margin-top:18px;
            margin-bottom:50px;
            
</style>